import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { useEffect } from 'react';
import { WidgetsOutlined } from '@material-ui/icons';
import * as logoFastpath from '../../images/fastpath.png';

export default function(){
  useEffect(() => {}, []);

  return (
    <>
      <Container className="mb-5">
        <Row className="col-12 mt-4 row">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Educação</h5>
        </Row>
        <Row>
          <Col md="3">
            <a
              href={'http://university.scansource.com/'}
              target="_blank"
              className="card-body mt-2 text-primary font-weight-bold d-block shadow bg-white rounded text-center pt-5"
              style={{ height: '12rem', marginBottom: '10px' }}
            >
              <img
                className="d-inline-block mb-3 icon-program"
                src={logoFastpath}
                alt=""
                width="115"
              />
              <p>FastPath University</p>
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
};
